import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROPERTIES_PAGE_SIZE,
  ADMIN_PROPERTY_LOOKUP_TYPES,
  buildAddressLookupRequest,
  buildCityLookupRequest,
  buildCreatedAtLookupRequest,
  buildOwnerEmailLookupRequest,
  buildOwnerNameLookupRequest,
  buildPostalCodeLookupRequest,
  buildPropertiesBrowseRequest,
  buildPropertyLookupRequest,
  buildUnitsLookupRequest,
} from './propertiesListRequest';

export {
  ADMIN_PROPERTIES_PAGE_SIZE,
  ADMIN_PROPERTY_LOOKUP_TYPES,
  buildAddressLookupRequest,
  buildCityLookupRequest,
  buildCreatedAtLookupRequest,
  buildOwnerEmailLookupRequest,
  buildOwnerNameLookupRequest,
  buildPostalCodeLookupRequest,
  buildPropertiesBrowseRequest,
  buildPropertyLookupRequest,
  buildUnitsLookupRequest,
};

/**
 * Admin properties list. Callables only — no client Firestore reads of properties.
 * @param {{
 *   mode: string,
 *   lookupType?: string,
 *   pageSize?: number,
 *   pageToken?: string,
 *   email?: string,
 *   ownerName?: string,
 *   address?: string,
 *   city?: string,
 *   postalCode?: string,
 *   unitsMin?: number,
 *   unitsMax?: number,
 *   createdAfter?: string,
 *   createdBefore?: string,
 * }} request
 */
export async function listAdminProperties(request) {
  const fn = httpsCallable(functions, 'listAdminProperties');
  const { data } = await fn(request);
  return data;
}

/**
 * Property 360 payload. Callables only.
 * @param {string} propertyId
 */
export async function getAdminProperty(propertyId) {
  const fn = httpsCallable(functions, 'getAdminProperty');
  const { data } = await fn({ propertyId });
  return data;
}
